export const onboarding = {
  skip: 'Kihagyás',
  back: 'Vissza',
  close: 'Bezárás',
  next: 'Következő',
  finish: 'Befejezés'
};
